import { useTranslation } from "react-i18next";
import { ViewSwitch } from "./ViewSwitch";

export const PresenceHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex flex-col md:flex-row gap-2 justify-between items-start">
      <div>
        <div className="mb-2 text-2xl font-bold leading-none">
          {t("presence.presence")}
        </div>
        <div className="text-base">{t("presence.headerText")}</div>
      </div>
      <ViewSwitch />
    </div>
  );
};
